import { keyMap } from '@locales/lokalise/keyMap';
import { EmptyObject } from 'components/shared/shared.interfaces';
import { ErrorCodesInfo, ErrorCodesData } from 'global.interfaces';
import i18next from 'i18next';

export const getErrorInfoByErrorCode = (
  errorCode: string,
  errorCodesData?: ErrorCodesData | EmptyObject,
  messagePlaceholders?: string[],
): ErrorCodesInfo | null => {
  const specificErrorCodesMap = getSpecificInfo(errorCode, errorCodesData);

  if (specificErrorCodesMap) {
    return specificErrorCodesMap;
  }

  const resourceName = `errors.${errorCode}`;

  const interpolationOptions = messagePlaceholders?.reduce((acc, value, index) => {
    acc[index as number] = value;
    return acc;
  }, {} as Record<number, string>);

  if (i18next.exists(resourceName)) {
    return {
      // @ts-ignore
      message: i18next.t(resourceName, { replace: interpolationOptions }),
      resourceName,
    };
  }

  return null;
};

const getSpecificInfo = (
  errorCode: string,
  errorCodesMapData?: ErrorCodesData | EmptyObject,
): ErrorCodesInfo | null => {
  if (errorCode == 'captcha.wasnt-passed') {
    const clientSupportEmail = errorCodesMapData?.clientSupportEmail ?? '';

    return {
      // @ts-ignore
      message: i18next.t(keyMap.errorsCaptchaCaptchaServerIsUnavailable, { 0: clientSupportEmail }),
      callback: () => window.location.reload(),
      showTime: 7000,
    };
  }

  return null;
};
